export default __webpack_public_path__ + "static/media/woman-rec.c64c8f04.svg";